export default "__VITE_ASSET__6JfXed1G__"